import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import Pedido from "../Shared/Interfaces/Pedido";
import Logo from "../../assets/LogoComFundo.png";
import WhatsAppLogo from "../../assets/LogoWhatsAppSemFundo.png";
import {
  formatDateToDDMMYYYY,
  formatToBRL,
} from "../../Utils/utils";
interface ImprimirPedidosProps {
  data: Pedido;
  numeroPedido: string;
}

// Estilos para o documento PDF
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between", // Ensures image on the left and text on the right
    alignItems: "center",
    marginBottom: 20,
  },
  section: {
    marginBottom: 5,
  },
  bold: {
    fontWeight: "bold",
  },
  table: {
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  info: {
    marginBottom: 3,
    marginTop: 3,
  },
  heading: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 10,
  },
  pedido: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
  },
  logo: {
    width: 100,
    height: 100,
  },
  whatsapplogo: {
    width: 15,
    height: 15,
    marginLeft: 5,
  },
  tableColProduto: {
    width: "52%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol12: {
    width: "12%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
  infoContainer: {
    flexDirection: "column", // Aligns text vertically in the right section
    textAlign: "right", // Aligns text to the right
  },
  divider: {
    marginVertical: 10, // Spacing above and below the divider
    borderBottomWidth: 1, // Line thickness
    borderBottomColor: "#000", // Line color (black in this case)
    width: "100%", // Full width
  },
  infoCliente: {
    marginTop: 5,
  },
});

const Divider = () => <View style={styles.divider} />;
const now = new Date();

const day = String(now.getDate()).padStart(2, "0");
const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
const year = now.getFullYear();

const formattedDate = `${day}/${month}/${year}`;

const ImprimirOrcamento: React.FC<ImprimirPedidosProps> = ({
  data,
  numeroPedido,
}) => (
  <Document>
    <Page style={styles.page}>
      {/* Header with Image on the Left and Info on the Right */}
      <View style={styles.header}>
        {/* Image on the left */}
        <Image style={styles.logo} src={Logo} />
        {/* Add the correct path to your image */}
        {/* Right-aligned Information */}
        <View style={styles.infoContainer}>
          <Text style={styles.heading}>WR PNEUS</Text>
          <Text style={styles.info}>CNPJ: 55.016.770/0001-14</Text>
          <Text style={styles.info}>
            Av. Domingos Potomati 127 - Batistini, São Bernardo do Campo - SP,
            Brasil
          </Text>
          <Text style={styles.info}>
            Telefone: (11) 98096-1227
            <Image style={styles.whatsapplogo} src={WhatsAppLogo} />
          </Text>
          <Text style={styles.info}>Email: wrpneus941@gmail.com</Text>
        </View>
      </View>
      <Divider />
      <View style={{ alignItems: "center" }}>
        <Text style={styles.pedido}>ORÇAMENTO: {numeroPedido}</Text>
      </View>
      <Divider />
      <View style={styles.section}>
        <Text style={styles.infoCliente}>
          <Text style={styles.bold}>Cliente: </Text>
          {data.cliente.nome}
        </Text>
        <Text style={styles.infoCliente}>
          <Text style={styles.bold}>CNPJ/CPF: </Text>
          {data.cliente.documento}
        </Text>
        <Text style={styles.infoCliente}>
          <Text style={styles.bold}>Fone: </Text>
          {data.cliente.telefone}
        </Text>
        <Text style={styles.infoCliente}>
          <Text style={styles.bold}>Endereço: </Text>
          {data.cliente.cep}
          {" - "}
          {data.cliente.logradouro}
          {" - "}
          {data.cliente.numero}
          {" - "}
          {data.cliente.complemento}
        </Text>
        <Text style={styles.infoCliente}>
          <Text style={styles.bold}></Text>
          {data.cliente.bairro}
          {" - "}
          {data.cliente.cidade}
          {" - "}
          {data.cliente.estado}
        </Text>
        <Text style={styles.infoCliente}>
          Orçamento válido até:{" "}
          {formatDateToDDMMYYYY(data.dataCriacao) ?? formattedDate}
        </Text>
      </View>
      <Divider />
      <View style={styles.section}>
        <Text style={styles.info}>Produtos</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableCol12}>
              <Text style={styles.tableCell}>Código</Text>
            </View>
            <View style={styles.tableColProduto}>
              <Text style={styles.tableCell}>Produto</Text>
            </View>
            <View style={styles.tableCol12}>
              <Text style={styles.tableCell}>Quantidade</Text>
            </View>
            <View style={styles.tableCol12}>
              <Text style={styles.tableCell}>Preço</Text>
            </View>
            <View style={styles.tableCol12}>
              <Text style={styles.tableCell}>Total</Text>
            </View>
          </View>
          {data.itensPedido.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <View style={styles.tableCol12}>
                <Text style={styles.tableCell}>
                  {(item as any).idKit && (item as any).idKit !== 0
                    ? (item as any).idKit
                    : (item as any).codigo && (item as any).codigo !== 0 && String(item.descricao || "").includes("[KIT]")
                      ? (item as any).codigo
                      : item.idProduto}
                </Text>
              </View>
              <View style={styles.tableColProduto}>
                <Text style={styles.tableCell}>{item.descricao}</Text>
              </View>
              <View style={styles.tableCol12}>
                <Text style={styles.tableCell}>{item.quantidade}</Text>
              </View>
              <View style={styles.tableCol12}>
                <Text style={styles.tableCell}>{formatToBRL(item.preco)}</Text>
              </View>
              <View style={styles.tableCol12}>
                <Text style={styles.tableCell}>
                  {formatToBRL(item.preco * item.quantidade)}
                </Text>
              </View>
            </View>
          ))}
        </View>
        <div style={{ textAlign: "right" }}>
          <Text style={{ marginTop: 5 }}>
            Valor Orçamento: {formatToBRL(data.valorTotal)}
          </Text>
          <Text style={styles.infoCliente}>
            Observações:{" "}
            {data.observacoes !== "" && data.observacoes != null
              ? data.observacoes
              : "Sem Observações"}
          </Text>
        </div>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center", // Centraliza horizontalmente
            alignItems: "center", // Centraliza verticalmente (dentro da altura do pai)
            marginTop: 50, // Corrigido: valor como número
            // height: "100%",           // Ocupa altura total (se for o container principal)
          }}
        >
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              width: "40%",
            }}
          >
            <Divider />
            <Text>Assinatura Vendedor</Text>
          </View>
        </View>
      </View>
    </Page>
  </Document>
);

export default ImprimirOrcamento;
